
export * from './pager-base.component';
export * from './pager-options.model';
export * from './pager.interface';
export * from './pager.model';



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-structures/pager/index.ts